import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { flexCenter } from '@seedlang/style_mixins';
import Text from 'components/text';
import { LanguageIcon } from '@seedlang/icons';
import TextResizer from 'components/text_resizer';

const Words = styled.div`
  margin-top: 20px;
`;

const WordsTitleRow = styled.div`
  position: relative;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  hr {
    position: absolute;
    z-index: 1;
    width: 100%;
    top: 0;
    bottom: 0;
    margin: auto;
  }
`;

const WordsTitle = styled.div`
  color: white;
  font-size: 14px;
  background: #333;
  display: inline-block;
  z-index: 2;
  padding: 10px;
  text-align: center;
`;

const WordRow = styled.div`
  ${flexCenter()}
  background: white;
  margin: 2px 10px;
  padding: 10px;
  border-radius: 5px;
`;

const WordRowText = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  text-align: left;
  padding-left: 5px;
  font-size: 16px;
  line-height: 20px;
  margin: ${props => props.margin};
  .icon-wrapper {
    margin-right: 5px;
    height: 20px;
  }
`;

const Sources = styled.div`
  display: flex;
  flex-direction: column;
`;

@observer
class IntroCardWords extends React.Component {

  render() {
    return (
      <Words>
        <WordsTitleRow>
          <WordsTitle>
            {this.props.title || 'Some Words That Will Help'}
          </WordsTitle>
        </WordsTitleRow>
        {
          this.props.deck.words.map(item => {
            if (item.vocabSourceListForUser(this.props.user)) {
              return (
                <WordRow
                  key={item.id}
                >
                  <WordRowText>
                    <LanguageIcon
                      languageId={this.props.deck.languageId}
                    />
                    <TextResizer
                      height={25}
                      width={(this.props.layout.innerDeckWidth / 2) - 50}
                      characterLength={item.targetTextWithDefiniteArticle ? item.targetTextWithDefiniteArticle.length : 0}
                      maximumFontSize={16}
                      lineHeightOffset={3}
                    >
                      <Text>
                        {item.targetTextWithDefiniteArticle}
                      </Text>
                    </TextResizer>
                  </WordRowText>
                  <WordRowText>
                    <Sources>
                      {
                        item.vocabSourceForUser(this.props.user).slice(0, 3).map(translationSource => {
                          return (
                            <WordRowText
                              margin='2px 0'
                              key={translationSource.id}
                            >
                              <LanguageIcon
                                languageId={translationSource.source && translationSource.source.languageId}
                                user={this.props.user}
                              />
                              {translationSource.source && translationSource.source.text}
                            </WordRowText>
                          );
                        })
                      }
                    </Sources>
                  </WordRowText>
                </WordRow>
              );
            } else {
              return null;
            }
          })
        }
      </Words>
    );
  }
}

export default IntroCardWords;